import {
  ADD_FILE_TO_PAGE_FILES,
  FETCH_PAGE_FILES,
  FETCH_USER_FILES,
  REMOVE_FILE,
  SET_IS_ALL_FILES_FETCHED,
  SUCCESS,
  UPLOAD_FILE,
} from '../actionTypes'
import {
  ADD_FILES,
  FETCH_SEARCH_USER_FILES,
  SET_FILES,
} from '../store/files/filesActionTypes'

const defaultState = {
  pageFiles: {},
  userFilesSearchValue: '',
  userFiles: {},
  isAllFilesFetched: false,
}

function removeFile(files, removableFileId) {
  return Object.values(files)
    .filter(file => file.id !== removableFileId)
    .reduce((acc, file) => ({ ...acc, [file.id]: file }), {})
}

export default function (state = defaultState, action) {
  const { type, payload } = action

  switch (type) {
    case FETCH_PAGE_FILES:
      return {
        ...state,
        pageFiles: {
          ...state.pageFiles,
          ...payload,
        },
      }
    case UPLOAD_FILE + SUCCESS:
      return {
        ...state,
        userFiles: {
          ...state.userFiles,
          ...payload,
        },
      }
    case FETCH_USER_FILES: {
      const files = payload
      return state.userFilesSearchValue
        ? {
            ...state,
            userFilesSearchValue: '',
            userFiles: files,
          }
        : {
            ...state,
            userFiles: {
              ...state.userFiles,
              ...files,
            },
          }
    }
    case FETCH_SEARCH_USER_FILES: {
      const { files, searchValue } = payload
      return {
        ...state,
        userFilesSearchValue: searchValue,
        userFiles:
          state.userFilesSearchValue === searchValue
            ? { ...state.userFiles, ...files }
            : files,
      }
    }
    case ADD_FILES:
      return {
        ...state,
        userFiles: {
          ...state.userFiles,
          ...payload,
        },
      }
    case REMOVE_FILE:
      return {
        ...state,
        userFiles: removeFile(state.userFiles, payload),
      }
    case SET_IS_ALL_FILES_FETCHED:
      return {
        ...state,
        isAllFilesFetched: payload,
      }
    case ADD_FILE_TO_PAGE_FILES:
      return {
        ...state,
        pageFiles: {
          ...state.pageFiles,
          [payload.id]: { ...payload },
        },
      }
    case SET_FILES: {
      return {
        ...state,
        ...payload,
      }
    }
    default:
      return state
  }
}

const getFilteredByType = (files, type) => {
  const filteredUserFiles = {}
  Object.keys(files)
    .filter(fileId => files[fileId].type.length && files[fileId].type === type)
    .forEach(fileId => {
      filteredUserFiles[fileId] = files[fileId]
    })

  return filteredUserFiles
}

export const getUserFilesByType = ({ userFiles }, type) =>
  getFilteredByType(userFiles, type)

export const getUserFiles = ({ userFiles }) => userFiles

export const getIsAllFilesFetched = ({ isAllFilesFetched }) => isAllFilesFetched

export const getFileById = ({ pageFiles, userFiles }, fileId) => {
  if (!fileId) {
    return null
  }

  return pageFiles[fileId] || userFiles[fileId]
}

export const getFilesByIds = (files, filesIds, asObject = true) => {
  if (asObject) {
    return filesIds.reduce(
      (prev, id) => ({
        ...prev,
        [id]: getFileById(files, id),
      }),
      {},
    )
  }

  return filesIds.map(id => getFileById(files, id))
}

export const getFilteredPageFontFiles =
  presentFontFiles =>
  ({ pageFiles } = {}) => {
    const allFontFiles = getFilteredByType(pageFiles, 'font')

    if (!presentFontFiles || Object.values(presentFontFiles).length === 0) {
      return allFontFiles
    }

    const filteredFontFiles = Object.entries(allFontFiles).reduce(
      (acc, [fileId, fileValue]) => {
        if (!presentFontFiles[fileId]) {
          acc[fileId] = fileValue
        }

        return acc
      },
      {},
    )

    return filteredFontFiles
  }

export const selectors = {
  getFileById,
  getFilesByIds,
}
